import React, { useState } from "react";
import CustomModal from "../../CustomModal/CustomModal";
import { useAuth } from "../../../features/auth/AuthContext";
import { useFileActions } from "../hooks/useFileActions";
import Loader from "../Components/Loader";

const RenameModal = ({
  open,
  close,
  file,
  primaryLabel = "Rename",
  secondaryLabel = "Cancel",
}) => {
  const fileName = file?.file_name;
  const [newFileName, setNewFileName] = useState("");
  const { token } = useAuth();

  const { renameFile, isRenaming } = useFileActions({
    token,
    closeModal: onClose,
  });

  const handleFileNameChange = (e) => {
    setNewFileName(e.target.value);
  };

  const handleSubmit = async () => {
    renameFile(file, newFileName, setNewFileName);
  };

  function onClose() {
    setNewFileName("");
    close();
  }

  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title={`Rename ${fileName}`}
      primaryLabel={!isRenaming ? primaryLabel : null}
      secondaryLabel={!isRenaming ? secondaryLabel : null}
      secondaryClick={onClose}
      primaryClick={handleSubmit}
      primaryDisbaled = {isRenaming}
    >
      {isRenaming ? (
        <Loader />
      ) : (
        <input
          type="text"
          value={newFileName}
          onChange={handleFileNameChange}
          placeholder="Enter new name..."
          className="border border-[#D5D7DA] text-[#555555] font-normal text-[0.8rem] w-full p-[12px] rounded-[10px]"
        />
      )}
    </CustomModal>
  );
};

export default RenameModal;
